import type {
  PatientPoolApi,
  PatientsPoolApiQuery,
  AssigmentPatientApiQuery,
} from "@/Modules/Models/Api/PatientsPool";

import { get2, post2 } from "./utils/FunctionalTherapyApi";

export function getPatientsPoolList(userUuid: string): Promise<PatientPoolApi[]> {
  return get2<PatientsPoolApiQuery, PatientPoolApi[]>("v3.0/assignments", {
    page_size: 100,
    assignable_to: userUuid,
  });
}

export function postAssigmentPatient(customerUuid: string): Promise<void> {
  return post2<AssigmentPatientApiQuery, void>("v1.0/users/me/assign", {
    customer_uuid: customerUuid,
  });
}
